import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ApplicationStoreService } from '../application-store.service';
import { DocumentSelectionChangedService } from './document-selection-changed-service';

@Injectable({ providedIn: 'root' })
export class ModelCorruptMonitor {
  private corruptEventSubject = new Subject<number>();
  corruptEvent$ = this.corruptEventSubject.asObservable();
  private corruptCount = 0;

  constructor(documentSelectionChangedService: DocumentSelectionChangedService, private applicationStoreService: ApplicationStoreService) {
    documentSelectionChangedService.selectionChanged$.subscribe(this.selectionChanged.bind(this));
  }

  private selectionChanged(_: Office.DocumentSelectionChangedEventArgs): void {
    Word.run(async (ctx) => {
      try {
        const namespace = ModelCorruptMonitor.getNamespace();
        if (!namespace) {
          return;
        }

        const nss = this.applicationStoreService.getNamespaceSettings(namespace);
        if (!nss) {
          return;
        }

        const nsp = await this.applicationStoreService.getNamespacePart(nss);

        const part = nsp.model;
        const xml = await part.getXml();
        if (!xml.includes('xml version')) {
          return;
        }

        this.corruptCount++;

        const corruptStart = xml.indexOf('&lt;?xml version=');
        const corruptEnd = xml.lastIndexOf('pkg:package&gt;') + 'pkg:package&gt;'.length;
        const before = xml.substring(0, corruptStart);
        const after = xml.substring(corruptEnd, xml.length);
        const fixedXml = before + after;
        await part.setXml(fixedXml);

        this.corruptEventSubject.next(this.corruptCount);

        await ctx.sync();
      } catch (err) {
        console.error('Error monitoring for model corruption.', err);
      }
    });
  }

  private static getNamespace(): string | null {
    const identityJson = window.localStorage.getItem('kp-identity');
    return identityJson ? JSON.parse(identityJson).namespace : null;
  }
}
